var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".info_svg__a6{fill:#97144d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__a6",
    d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.545A6.545 6.545 0 1114.545 8 6.553 6.553 0 018 14.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__a6",
    d: "M7.999 3.394a.97.97 0 10.969.97.971.971 0 00-.969-.97zM7.998 6.788a.727.727 0 00-.727.727v4.364a.728.728 0 001.455 0V7.515a.727.727 0 00-.728-.727z"
  })));
}
export default SvgInfo;